import '@hotwired/turbo-rails'
Turbo.session.drive = false // disable turbo app wide and add for specific elements gradually

// Import jQuery and make it globally available
import jquery from 'jquery'
window.jQuery = jquery
window.$ = jquery

import Rails from '@rails/ujs'
Rails.start()

import * as ActiveStorage from '@rails/activestorage'
ActiveStorage.start()

import * as bootstrap from 'sard_core/vendor/assets/bootstrap/javascripts/bootstrap.js'
window.bootstrap = bootstrap

import TextareaAutogrow from "stimulus-textarea-autogrow"
application.register('textarea-autogrow', TextareaAutogrow)

// action cable
import consumer from './channels/consumer'
import CableReady from 'cable_ready'
CableReady.initialize({ consumer })
import './channels'

import { application } from './controllers/application'

// Sard Core
import 'sard_core/app/javascript/shared/core'

import FlashController from 'sard_core/app/javascript/controllers/flash_controller'
application.register('flash', FlashController)

import TomSelectController from 'sard_core/app/javascript/controllers/tomselect_controller'
application.register('tomselect', TomSelectController)

import OtpDigitFieldController from 'sard_core/app/javascript/controllers/otp_digit_field_controller'
application.register('otp-digit-field', OtpDigitFieldController)
// END Sard Core

import './controllers'
import './custom'

// Turbo Stream Actions
import { StreamActions } from "@hotwired/turbo"

StreamActions.redirect = function () {
  Turbo.visit(this.getAttribute('target'))
}
// END Turbo Stream Actions
